import { INotFoundPagesProps } from "./NotFoundPages";

export const View = (props: INotFoundPagesProps) => {
  return (
    <div className="flex-container col justify-content--between align-items--center not-found--container">
      <h3 className="font-ctm--semibold mt-5">{props.title || "Not Found"}</h3>

      {props.message || "The requested page or resource could not be found..."}

      {props.hideWhatCanYouDoMessage ? null : (
        <div className="flex-container col align-items--center">
          <p className="switchapp-small text-danger">What you can do?</p>
          <p className="switchapp-small">
            Contact the merchant and inform them the link is no longer working
            or restart the payment from the merchant's checkout page.
          </p>
        </div>
      )}
    </div>
  );
};
